namespace AppKitchen {
    export module InactivityLogout {
        import GlobalSettings = AppKitchen.GlobalSettings;

        var userInactivityTimeoutMinutes = 30;
        var timeoutTimerId;
        var started = 0;
        var remaining = 0;

        function startTimer(fromEvent = true) {
            started = (new Date()).getTime();
            var inactivityTimerStart = localStorage.getItem("InactivityTimerStart");
            if (inactivityTimerStart !== null && !fromEvent) {
                started = Number.parseInt(inactivityTimerStart);
            }
            else {
                localStorage.setItem("InactivityTimerStart", started.toString());
            }
        }
        function resetTimer() {
            window.clearTimeout(timeoutTimerId);
            localStorage.setItem("InactivityTimerStart", started.toString());
            startTimer(true);
        }
        // Logout the user.
        function idleTimeout() {
            localStorage.removeItem("InactivityTimerStart");
            AppKitchen.LoginManager.logout(true);
        }
        function setupTimers() {
            document.addEventListener("mousedown", resetTimer, false);
            document.addEventListener("keypress", resetTimer, false);
            document.addEventListener("touchmove", resetTimer, false);
            startTimer();
        }
        
        export function setupTimersAndStart() {
            if (!GlobalSettings.userInactivityDetectionEnabled)
                return;
            if (GlobalSettings.userInactivityTimeoutMinutes != null) {
                userInactivityTimeoutMinutes = GlobalSettings.userInactivityTimeoutMinutes;
            } else {
                userInactivityTimeoutMinutes = 30;
            }
            userInactivityTimeoutMinutes = userInactivityTimeoutMinutes * 60000; // Convert minutes to milliseconds
            localStorage.setItem("InactivityTimerStart", userInactivityTimeoutMinutes.toString());
            setupTimers();
            initializeTimer("a-header-timer-ticker", userInactivityTimeoutMinutes);
        }

        function initializeTimer(id, endtime) {
            var timerElement = document.getElementsByClassName(id)[0];
            var timeinterval = setInterval(function () {
                if (timerElement == null) {
                    timerElement = document.getElementsByClassName(id)[0];
                }
                else {
                    remaining = (new Date()).getTime() - started;
                    var totalTime = endtime - remaining;
                    if (totalTime <= 0) {
                        idleTimeout();
                    }
                    timerElement.innerHTML = parseMillisecondsIntoReadableTime(totalTime);
                }
                started = Number.parseInt(localStorage.getItem("InactivityTimerStart"));
            }, 1000);
        }

        function parseMillisecondsIntoReadableTime(milliseconds){
            //Get hours from milliseconds
            var hours = milliseconds / (1000*60*60);
            var absoluteHours = Math.floor(hours);
            var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;
          
            //Get remainder from hours and convert to minutes
            var minutes = (hours - absoluteHours) * 60;
            var absoluteMinutes = Math.floor(minutes);
            var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;
          
            //Get remainder from minutes and convert to seconds
            var seconds = (minutes - absoluteMinutes) * 60;
            var absoluteSeconds = Math.floor(seconds);
            var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;
          
            return h + ':' + m + ':' + s;
        }
        

    }
}